// extracted by mini-css-extract-plugin
export default {"BackIcon":"BackIcon_BackIcon__TJh04"};